import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Dropdown } from '../../ui';

export const GymLocation = reduxForm({ form: 'GymLocation' })(
  ({
    onSelect,
    showLabel = false,
    gymLocationList = [],
    defaultGym = null,
    useTransparentTheme = false,
    useFullScreenWidth = false,
    controlStyle = null,
    controlTextStyle = null,
    optionsStyle = null,
    isRequired = false,
    iconSize = null,
    mainDropdownContainerStyle = null,
    menuListStyle = {},
    adjustFrameOptions = {},
  }) => {
    const options = gymLocationList;
    const rowWidth = useFullScreenWidth ? '93%' : '83%';
    return (
      <Field
        webAbsolute
        useTransparentTheme={useTransparentTheme}
        name='branch'
        showLabel={showLabel}
        placeholder='Where will you be working out?'
        valueKey='name'
        displayKey='displayName'
        defaultValue={defaultGym}
        options={options}
        component={Dropdown}
        controlStyle={controlStyle}
        controlTextStyle={controlTextStyle}
        optionsStyle={optionsStyle}
        isRequired={isRequired}
        rowWidth={rowWidth}
        onSelect={onSelect}
        iconSize={iconSize}
        useFullScreenWidth={useFullScreenWidth}
        adjustFrameOptions={adjustFrameOptions}
        menuListStyle={menuListStyle}
        mainDropdownContainerStyle={mainDropdownContainerStyle}
        props={{
          disabled: !(options && options.length > 1),
        }}
      />
    );
  },
);

GymLocation.propTypes = {
  onSelect: PropTypes.func.isRequired,
};
